import { FC, Fragment } from "react";
import { useUser } from "@/core/context/AppContext.ts";
import { KolLink } from "@public-ui/react";
import { LinkOnCallbacksPropType } from "@public-ui/components";
import { useNavigate } from "react-router-dom";

interface IProfileButtonProps {
    usernamePadding: string;
}

export const ProfileButton: FC<IProfileButtonProps> = (props) => {
    const user = useUser();
    const navigate = useNavigate();
    const eventHandler: LinkOnCallbacksPropType = {
        onClick: () => navigate("/profile"),
    };
    // prettier-ignore
    return user == null ? <Fragment /> : (
        <div className={`username ${props.usernamePadding}`}>
            <KolLink
                _icons={{ left: `icon icon-person` }}
                _href={""}
                _label={user.displayName}
                _on={eventHandler}
                _ariaDescription={"Zum Benutzerprofil"}
            />
        </div>
    );
};
